import { render } from "./FranchiseStores.vue?vue&type=template&id=15676dab"
import script from "./FranchiseStores.vue?vue&type=script&lang=js"
export * from "./FranchiseStores.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.1.5_lodash@4.17.21_react-dom@18.2.0_react@18.2.0__e596fc48390f8e4bef02dc94fa5183e2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__